// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeHeroSection_home-hero-section__Z87Sk {
  display: flex;
  padding: 80px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;
  align-self: stretch;
  background: var(--background-color-2);
}
.HomeHeroSection_home-hero-section--title__THj\\+- {
  color: var(--accent-color);
  font-size: 52px;
  font-weight: 700;
  text-align: center;
}
.HomeHeroSection_home-hero-section--statistics__Ybtmz {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.HomeHeroSection_home-hero-section--statistics--item__fDSg4 {
  display: inline-flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
.HomeHeroSection_home-hero-section--statistics--item__container__IAEk0 {
  display: flex;
  justify-content: center;
}
.HomeHeroSection_home-hero-section--statistics--item--icon__RxkC4 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  padding: 12px;
  box-shadow: -2px 2px 4px 1px rgba(0, 0, 0, 0.25);
}
.HomeHeroSection_home-hero-section--statistics--item--icon__RxkC4 svg {
  width: 24px;
  height: 24px;
}
.HomeHeroSection_home-hero-section--statistics--item--icon__RxkC4 svg path {
  stroke: var(--accent-color);
}
.HomeHeroSection_home-hero-section--statistics--item--content__lEz3j {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.HomeHeroSection_home-hero-section--statistics--item--content--value__hhvJ0 {
  text-align: center;
  color: var(--accent-color);
  font-size: 40px;
  font-weight: 600;
}
.HomeHeroSection_home-hero-section--statistics--item--content--title__OyBlU {
  text-align: center;
  color: var(--accent-color-medium);
  font-size: 16px;
}
@media only screen and (max-width: 480px) {
  .HomeHeroSection_home-hero-section__Z87Sk {
    gap: 40px;
  }
  .HomeHeroSection_home-hero-section--title__THj\\+- {
    font-size: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeHeroSection/HomeHeroSection.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;AACF;AACE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAEI;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAAN;AAEM;EACE,aAAA;EACA,uBAAA;AAAR;AAGM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,gDAAA;AADR;AAGQ;EACE,WAAA;EACA,YAAA;AADV;AAGU;EACE,2BAAA;AADZ;AAMM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAJR;AAMQ;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AAJV;AAOQ;EACE,kBAAA;EACA,iCAAA;EACA,eAAA;AALV;AAWE;EA3EF;IA4EI,SAAA;EARF;EASE;IACE,eAAA;EAPJ;AACF","sourcesContent":[".home-hero-section {\n  display: flex;\n  padding: 80px 0px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 80px;\n  align-self: stretch;\n  background: var(--background-color-2);\n\n  &--title {\n    color: var(--accent-color);\n    font-size: 52px;\n    font-weight: 700;\n    text-align: center;\n  }\n\n  &--statistics {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    &--item {\n      display: inline-flex;\n      padding: 20px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 24px;\n\n      &__container {\n        display: flex;\n        justify-content: center;\n      }\n\n      &--icon {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        border-radius: 8px;\n        padding: 12px;\n        box-shadow: -2px 2px 4px 1px rgba(0, 0, 0, 0.25);\n\n        svg {\n          width: 24px;\n          height: 24px;\n\n          path {\n            stroke: var(--accent-color);\n          }\n        }\n      }\n\n      &--content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 8px;\n\n        &--value {\n          text-align: center;\n          color: var(--accent-color);\n          font-size: 40px;\n          font-weight: 600;\n        }\n\n        &--title {\n          text-align: center;\n          color: var(--accent-color-medium);\n          font-size: 16px;\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    gap: 40px;\n    &--title {\n      font-size: 36px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-hero-section": `HomeHeroSection_home-hero-section__Z87Sk`,
	"home-hero-section--title": `HomeHeroSection_home-hero-section--title__THj+-`,
	"home-hero-section--statistics": `HomeHeroSection_home-hero-section--statistics__Ybtmz`,
	"home-hero-section--statistics--item": `HomeHeroSection_home-hero-section--statistics--item__fDSg4`,
	"home-hero-section--statistics--item__container": `HomeHeroSection_home-hero-section--statistics--item__container__IAEk0`,
	"home-hero-section--statistics--item--icon": `HomeHeroSection_home-hero-section--statistics--item--icon__RxkC4`,
	"home-hero-section--statistics--item--content": `HomeHeroSection_home-hero-section--statistics--item--content__lEz3j`,
	"home-hero-section--statistics--item--content--value": `HomeHeroSection_home-hero-section--statistics--item--content--value__hhvJ0`,
	"home-hero-section--statistics--item--content--title": `HomeHeroSection_home-hero-section--statistics--item--content--title__OyBlU`
};
export default ___CSS_LOADER_EXPORT___;
